module.exports = __webpack_public_path__ + "static/media/bg_btm.0e32e865.jpg";